import { Route, Routes, Navigate } from "react-router";
import { RequiredPermission } from '../authentication/RequiredPermission';
import { 
  AgregarCapacitaciones,
  CapacitacionesSupervisor
} from "../pages/Capacitaciones";

export const RutasCapacitaciones = () => {
  return (
    <Routes>
      
      <Route element={<RequiredPermission permission={['ROLE_CREAR_CAPACITACION']}/>}>
        <Route path="/empleados/agregar" element={<AgregarCapacitaciones />}/>
        <Route path="/empleados" element={<CapacitacionesSupervisor />}/>
      </Route>

      <Route path='/*' element={<Navigate to="/" replace />} />

    </Routes>
  );
};
